import React from 'react';
import { Button } from 'react-bootstrap';
import CarouselSv from '../components/home/CarouselSv';
import ProjectsSv from '../components/home/ProjectsSv';

const Home: React.FC = () => {
    return (<>
        <section>
            <CarouselSv />
        </section>
        <section className='containerView positionAbsolute'>
           <ProjectsSv />
        </section>
    </>
    );
};

export default Home;
